import { Outlet, createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

export const Route = createFileRoute('/_admin/admin')({
  component: AdminSection,
});

function AdminSection(): React.ReactElement {
  return <Outlet />;
}
